import React, { useState } from "react";
import useUser from "../hooks/useUser";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./pages/Dashboard/Dashboard";
import UserManagement from "./pages/UserManagement/UserManagement";
import UserRoles from "./pages/UserRoles/UserRoles";
import KnowledgeBases from "./pages/KnowledgeBases/KnowledgeBases";
import AccessToolsPermissions from "./pages/AccessToolsPermissions/AccessToolsPermissions";
import Profile from "./pages/Profile/Profile";
import Suscriptions from "./pages/Suscriptions/Suscriptions";
import PaymentHistory from "./pages/Suscriptions/PaymentHistory/PaymentHistory";
import CreditUsage from "./pages/Suscriptions/CreditUsage/CreditUsage";
import Usage from "./pages/Usage/Usage";
import Integrations from "./pages/Integrations/Integrations";
import Chat from "./pages/Chat/Chat";
import Organization from "./pages/Organization/Organization";
import Sidebar from "./components/Sidebar/Sidebar";
import Header from "./components/Header/Header";
import navigation from "./navigation";
import PrivateRoute from "../PrivateRoute";
import Footer from "./components/Footer/Footer";
import "./index.css";
import "./OwlyManage.css";

function OwlyManage() {
  const { user } = useUser();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="owly-manage-root">
      <div className="flex h-screen">
        {/* Sidebar (solo visible en desktop) */}
        <div className="hidden lg:block">
          <Sidebar isOpen={true} onClose={() => {}} />
        </div>
        {/* Sidebar tipo drawer en mobile */}
        <div className="lg:hidden">
          <Sidebar
            isOpen={sidebarOpen}
            onClose={() => setSidebarOpen(false)}
          />
        </div>

        {/* Main content */}
        <div className="owly-manage-main">
          <Header
            onMenuClick={() => setSidebarOpen(!sidebarOpen)}
            navigation={navigation}
            sidebarOpen={sidebarOpen}
          />

          <main className="flex-1 overflow-auto">
            <Routes>
              {/* Solo staff puede ver estas rutas */}
              <Route
                path="/"
                element={
                  <PrivateRoute user={user} allowedForStaffOnly={false}>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="users"
                element={
                  <PrivateRoute user={user} allowedForStaffOnly={true}>
                    <UserManagement />
                  </PrivateRoute>
                }
              />
              <Route
                path="user-roles"
                element={
                  <PrivateRoute user={user} allowedForStaffOnly={true}>
                    <UserRoles />
                  </PrivateRoute>
                }
              />
              <Route
                path="knowledge-bases"
                element={
                  <PrivateRoute user={user} allowedForStaffOnly={true}>
                    <KnowledgeBases />
                  </PrivateRoute>
                }
              />
              <Route
                path="access-tools-permissions"
                element={
                  <PrivateRoute user={user} allowedForStaffOnly={true}>
                    <AccessToolsPermissions />
                  </PrivateRoute>
                }
              />
              <Route
                path="usage"
                element={
                  <PrivateRoute user={user} allowedForStaffOnly={true}>
                    <Usage />
                  </PrivateRoute>
                }
              />
              <Route
                path="integrations"
                element={
                  <PrivateRoute user={user} allowedForStaffOnly={true}>
                    <Integrations />
                  </PrivateRoute>
                }
              />
              <Route
                path="organization"
                element={
                  <PrivateRoute user={user} allowedForStaffOnly={true}>
                    <Organization />
                  </PrivateRoute>
                }
              />
              {/* Todos pueden ver su perfil y chat */}
              <Route
                path="profile"
                element={
                  <PrivateRoute user={user}>
                    <Profile />
                  </PrivateRoute>
                }
              />
              <Route
                path="suscriptions"
                element={
                  <PrivateRoute user={user}>
                    <Suscriptions />
                  </PrivateRoute>
                }
              />
              <Route
                path="suscriptions/payment-history"
                element={
                  <PrivateRoute user={user}>
                    <PaymentHistory />
                  </PrivateRoute>
                }
              />
              <Route
                path="suscriptions/credit-usage"
                element={
                  <PrivateRoute user={user}>
                    <CreditUsage />
                  </PrivateRoute>
                }
              />
              <Route
                path="chat"
                element={
                  <PrivateRoute user={user}>
                    <Chat />
                  </PrivateRoute>
                }
              />
              {/* Cualquier otra ruta redirige a perfil */}
              <Route
                path="*"
                element={<Navigate to="/app/profile" replace />}
              />
            </Routes>
          </main>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default OwlyManage;
